export function findConversation(state, npc) {
  return state.conversations
}

